export default function redirectToNA() {
  window.location.replace('/my/na');
}
